import React  from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { RootState } from "../../../../store";
import RequestDetailedHeaderTitle from "./request-detailed-header-title";

import "./styles.less";
import RequestDetailedHeaderStages from "./request-detailed-header-stages";


type RequestDetailedHeaderProps = {
  onBackClick: () => void;
 
};

const RequestDetailedHeader: React.FC<RequestDetailedHeaderProps> = ({ onBackClick }) => {
  const requestData = useSelector((state: RootState) => state.administration.requests.currentRequest);
  const requestStages = useSelector((state: RootState) => state.administration.requests.requestStages);
  const user = useSelector((state:RootState) => state.auth.user)as unknown as Partial<{ screenButtons: {id:string}[]}>;


  const hasManualApproveBtn = user?.screenButtons?.find(btn => btn.id === "manual_approve")

  return (
    <Box className="request-detailed-header">
      <RequestDetailedHeaderTitle requestData={requestData} onBackClick={onBackClick} hasManualApproveBtn={!!hasManualApproveBtn}/>
      <RequestDetailedHeaderStages requestData={requestData} requestStages={requestStages} />
    </Box>
  );
};

export default RequestDetailedHeader;
